import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../_db";

/**
 * Hook to fetch support email addresses from Firestore settings
 * @returns Comma-separated support email addresses for mailto links
 */
export const useSupportEmail = () => {
  const [supportEmail, setSupportEmail] = useState<string>("support@assimagra.pt");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSupportEmail = async () => {
      try {
        console.log("[useSupportEmail] Fetching email settings from Firestore...");
        const emailSettingsRef = doc(db, "settings", "email");
        const emailSettingsDoc = await getDoc(emailSettingsRef);

        console.log("[useSupportEmail] Document exists:", emailSettingsDoc.exists());

        if (emailSettingsDoc.exists()) {
          const data = emailSettingsDoc.data();
          console.log("[useSupportEmail] Document data:", data);
          const recipients = data?.recipients;
          console.log("[useSupportEmail] Recipients:", recipients);

          // Join all emails with comma for mailto link (supports multiple recipients)
          if (Array.isArray(recipients) && recipients.length > 0) {
            const emailString = recipients.join(",");
            console.log("[useSupportEmail] Setting email to:", emailString);
            setSupportEmail(emailString);
          } else {
            console.warn("[useSupportEmail] Recipients is not a valid array:", recipients);
          }
        } else {
          console.warn("[useSupportEmail] Document does not exist");
        }
      } catch (error) {
        console.error("[useSupportEmail] Error fetching support email:", error);
        // Keep the default fallback email
      } finally {
        setLoading(false);
      }
    };

    fetchSupportEmail();
  }, []);

  return { supportEmail, loading };
};
